import Backbone from 'backbone';
import React from 'react';

import AaSequenceAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import AaSequenceAlignmentToolbar from './AaSequenceAlignmentToolbar';
import {renderAlignmentSVG} from './AaSequenceAlignmentUtil';

export default class AaSequenceAlignmentTabOptionsView extends Backbone.View<AaSequenceAlignmentTabState> {
  _boundRenderAlignmentSVG!: () => Promise<SVGSVGElement>;
  override initialize(): void {
    this._boundRenderAlignmentSVG = this._renderAlignmentSVG.bind(this);
    this.listenTo(this.model.get('selection'), 'change:start change:end', this.render.bind(this));
  }

  _renderAlignmentSVG(): Promise<SVGSVGElement> {
    return renderAlignmentSVG(this.model);
  }

  override render(): this {
    const visibilityOptions = this.model.get('visibilityOptions');
    const alignment = this.model.get('alignment');
    const selection = this.model.get('selection');
    const selectionProps = {
      start: selection ? selection.start() : 0,
      end: selection ? selection.end() : null,
    };
    let element;
    if (alignment) {
      element = (
        <AaSequenceAlignmentToolbar
          visibilityOptions={visibilityOptions}
          alignment={alignment}
          renderAlignmentSVG={this._boundRenderAlignmentSVG}
          selection={selectionProps}
        />
      );
    } else {
      element = <div />;
    }
    renderToDOM(element, this.el);
    return this;
  }
}
